import { OrderDirection } from '../types/misc'

export const APP_NAME = 'CPad'

/**
 @see https://date-fns.org/docs/format for date formats.
 */
export const DATE_FORMATS = {
  DAY_MONTH_YEAR: 'dd/LL/yyyy', // 05/03/2002
  DAY_MONTH_YEAR_TIME: 'dd/LL/yyyy, h:mm a', // 05/03/2002, 2:53 PM
  MONTH_YEAR: 'LL/yyyy', // 05/2002
  TIME: 'h:mmaaa', // '2:53pm'
  YEAR_MONTH_DAY: 'yyyy-LL-dd', // 2002-05-03
  YEAR_MONTH_DAY_TIME: 'yyyy-LL-dd H:mm', // 2002-05-03 14:53
  MONTH_DAY_YEAR: 'MMM d, yyyy', // May 3, 2002
  MONTH_DAY_YEAR_TIME: 'MMM d, yyyy h:mm a', // May 3, 2002 2:53 PM
  LONG_DAY_MONTH_YEAR: 'do MMMM yyyy', // 3rd November 2002
  LONG_DAY_MONTH_YEAR_TIME: 'do MMMM yyyy h:mm a', // 3rd November 2002, 2:52 PM
}

export const EMAIL_ADDRESSES = {
  support: 'support@cpad.app',
}

export const ERROR_MESSAGES = {
  genericServerError:
    'Sorry but there was a problem on our side. ' +
    'Our team has been notified and will attempt to fix the issue as soon ' +
    'as possible. Please try again later.',
  required: 'This field is required',
}

export const TOOLTIPS = {
  photoPrivacyNote: (
    <>
      Please be aware that any photos uploaded will have a publicly accessible
      URL. This URL will be very long and almost impossible to guess but because
      it's publicly accessible, it means that if you share the URL with someone,
      they will continue to have access to the photo even if they're not logged
      into your account.
    </>
  ),
}

export const LOCAL_STORAGE_KEYS = {
  isProgrammaticReload: 'isProgrammaticReload',
}

export const ORDER_DIRECTION: Record<OrderDirection, OrderDirection> = {
  asc: 'asc',
  desc: 'desc',
}

export const THEME_PALETTE = {
  borderColor: '#dee6ed', // --bs-border-color
  disabled: '#d3d3d3',
  'gray-100': '#f4f7f9',
  'gray-200': '#e2e8ee',
  'gray-300': '#dee6ed',
  'gray-400': '#ced4da',
  'gray-500': '#adb5bd',
  'gray-600': '#6c757d',
  'gray-700': '#495057',
  'gray-800': '#020202',
  'gray-900': '#212529',
  textMutedColor: 'var(--bs-secondary-color)',
}

export const TIP_TAP_EXTENSION = {
  link: 'link',
}

export const MAX_FILE_SIZE_LIMIT_MB = 20

export const Z_INDEX = {
  globalSearch: 1000,
}
